module.exports = __webpack_public_path__ + "static/media/home-charger-screenshot.a418ff5a.png";